class AutomationUtil {

  static StaticAssign = 1;
  static FieldAssign = 2;
  static RelatableAssign = 3;
  
  static Options = [
    { id: AutomationUtil.StaticAssign, value: AutomationUtil.StaticAssign, label: 'Static Assign', status: 1 },
    { id: AutomationUtil.FieldAssign, value: AutomationUtil.FieldAssign, label: 'Field Assign', status: 1 },
    { id: AutomationUtil.RelatableAssign, value: AutomationUtil.RelatableAssign, label: 'Relatable Assign', status: 1 }
  ]
}
export default AutomationUtil;